// Shared presets for Hero / Footer visual controls (Post-Launch refinement scope).
// NOTE: Tailwind class strings below are written as literals so they survive purge.

export const HERO_LOGO_PX = { small: 64, medium: 96, large: 140, xlarge: 180 };
export const FOOTER_LOGO_PX = { small: 56, medium: 88, large: 120, xlarge: 150 };

// Resolve a size setting (preset name or numeric custom px) to a pixel number.
export const resolveLogoPx = (size, map, fallback = "xlarge") => {
  if (typeof size === "number" && size > 0) return size;
  if (typeof size === "string" && /^\d+$/.test(size.trim())) return parseInt(size, 10);
  return map[size] || map[fallback];
};

export const HERO_HEIGHT_PAD = {
  compact: "py-8 sm:py-10",
  standard: "py-16 sm:py-24",
  tall: "py-28 sm:py-40",
  full: "py-20 sm:py-24",
};
export const HERO_HEIGHT_MINH = {
  compact: "min-h-[380px] sm:min-h-[420px]",
  standard: "min-h-[440px] sm:min-h-[500px]",
  tall: "min-h-[520px] sm:min-h-[600px]",
  full: "min-h-[100svh]",
};

// Buffer = breathing room directly above / below the hero TEXT block (margins).
export const HERO_BUFFER_TOP = {
  tight: "mt-0",
  normal: "mt-4",
  spacious: "mt-10",
  extra: "mt-16",
};
export const HERO_BUFFER_BOTTOM = {
  tight: "mb-0",
  normal: "mb-4",
  spacious: "mb-10",
  extra: "mb-16",
};

const FOCAL_Y = { top: "top", upper: "25%", center: "center", lower: "75%", bottom: "bottom" };
const FOCAL_X = { left: "left", center: "center", right: "right" };
export const objectPosition = (fx, fy) => `${FOCAL_X[fx] || "center"} ${FOCAL_Y[fy] || "center"}`;

// Option lists for the Homepage Editor selects.
export const LOGO_SIZE_OPTS = [
  { v: "small", label: "Small" },
  { v: "medium", label: "Medium" },
  { v: "large", label: "Large" },
  { v: "xlarge", label: "Extra Large" },
  { v: "custom", label: "Custom (px)" },
];
export const HERO_HEIGHT_OPTS = [
  { v: "compact", label: "Compact" },
  { v: "standard", label: "Standard" },
  { v: "tall", label: "Tall" },
  { v: "full", label: "Full screen" },
];
export const BUFFER_OPTS = [
  { v: "tight", label: "Tight" },
  { v: "normal", label: "Normal" },
  { v: "spacious", label: "Spacious" },
  { v: "extra", label: "Extra Spacious" },
];
export const FOCAL_Y_OPTS = [
  { v: "top", label: "Top" },
  { v: "upper", label: "Upper" },
  { v: "center", label: "Center" },
  { v: "lower", label: "Lower" },
  { v: "bottom", label: "Bottom" },
];
export const FOCAL_X_OPTS = [
  { v: "left", label: "Left" },
  { v: "center", label: "Center" },
  { v: "right", label: "Right" },
];
export const VIDEO_TIMING_OPTS = [
  { v: "immediately", label: "Immediately" },
  { v: "delay", label: "After a few seconds" },
  { v: "scroll", label: "After the visitor scrolls" },
];
export const VIDEO_CATEGORY_OPTS = [
  { v: "welcome", label: "Welcome" },
  { v: "news", label: "News update" },
  { v: "highlight", label: "Highlight" },
  { v: "support", label: "Support video" },
  { v: "family", label: "Family help" },
];
